import { Box, Button, Chip, LinearProgress, Stack, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getProfile } from '../../reducer/profileSlice';
import { getEOCHistory, setEOCHistory } from '../../reducer/eocHistorySlice';
import dayjs from "dayjs";
import CreateEOCDialog from './CreateEOCDialog';
import { setEOCConfig } from "../../reducer/eocConfigSlice";
import { setActivityActive } from '../../reducer/activityActiveSlice';
import { getEOCActive, setEOCActive } from '../../reducer/eocActiveSlice';
import { setTab } from '../../reducer/tabSlice';
import CustomOpenEOC from './CustomOpenEOC';
import { setActivityConfig } from '../../reducer/activityConfigSlice';
import HistoryDetailDialog from './HistoryDetailDialog';
import AddActivity from './EOCActivity/AddActivity';
import DetailActivity from './EOCActivity/DetailActivity';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { DataGridPro, GridToolbarContainer, GridToolbarQuickFilter } from '@mui/x-data-grid-pro';


function MyEOC() {

    function CustomToolbar(props) {

        return (
            <GridToolbarContainer {...props} className="flex justify-between mt-2 ml-2 mr-3">
                <GridToolbarQuickFilter variant="outlined" size="small" />

            </GridToolbarContainer>
        );
    }

    const columns = [
        {
            field: 'start_eoc_timestamp_column',
            headerName: 'วันที่เริ่มต้น',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            valueGetter: (value) => {
                if (value?.row?.start_eoc_timestamp) { // บางข้อมูลไม่มี start_eoc_timestamp
                    return dayjs(parseInt(value?.row?.start_eoc_timestamp)).locale("th").format("YYYY-MM-DD");
                }
                else {
                    if (value?.row?.ep_timestamp) {
                        return dayjs(parseInt(value?.row?.ep_timestamp)).locale("th").format("YYYY-MM-DD");
                    } else {
                        return '-';
                    }
                }
            }
        },
        {
            field: 'start_week',
            headerName: 'สัปดาห์ที่',
            type: 'number',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            valueGetter: (value) => {
                if (value?.row?.start_eoc_week) {
                    return value?.row?.start_eoc_week;
                } else {
                    if (value?.row?.ep_week) {
                        return value?.row?.ep_week;
                    } else {
                        return '-';
                    }
                }
            },
        },
        {
            field: 'participating_org_value',
            headerName: 'วิธีการ',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            valueGetter: (value) => {
                if (value?.row?.participating_org) {
                    return 'เปิด EOC';
                } else {
                    return 'ไม่เปิด EOC';
                }
            },
            renderCell: (params) => {
                if (params?.row?.participating_org) {
                    return <Chip className='bg-orange-900 bg-opacity-20' label="เปิด EOC" />;
                } else {
                    return <Chip className='bg-green-900 bg-opacity-20' label="ไม่เปิด EOC" />;
                }
            }
        },
        {
            field: 'closed_eoc_timestamp',
            headerName: 'วันที่สิ้นสุด',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            valueGetter: (value) => {
                if (value?.row?.closed_eoc_timestamp) { // บางข้อมูลไม่มี closed_eoc_timestamp
                    return dayjs(parseInt(value?.row?.closed_eoc_timestamp)).locale("th").format("YYYY-MM-DD");
                } else {
                    return '-';
                }
            }
        },
        {
            field: 'incident_commander',
            headerName: 'ผู้บัญชาการเหตุการณ์',
            flex: 1,
            align: 'left',
            headerAlign: 'left',
            valueGetter: (value) => {
                if (value?.row?.incident_commander?.ic_name) {
                    return `${value.row.incident_commander.ic_name}`;
                } else {
                    return '-';
                }
            }
        },
        {
            field: 'details',
            headerName: '',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                return <Button variant="outlined" size='small' onClick={() => onClickDetail(params.row)}>รายละเอียด</Button>;
            }
        },
    ];

    const profile = useSelector(getProfile);
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const eocHistory = useSelector(getEOCHistory)
    const [openCreate, setOpenCreate] = useState(false);
    const [headerLabel, setHeaderLabel] = useState("");
    const eocActive = useSelector(getEOCActive);
    const [notOpenEOC, setNotOpenEOC] = useState(false);

    const [openDetailActivity, setOpenDetailActivity] = useState(false);
    const [historySelected, setHistorySelected] = useState();
    const [dataActivityHistory, setDataActivityHistory] = useState();

    const [openDetail, setOpenDetail] = useState(false);
    const [dataActivity, setDataActivity] = useState();

    const callActivityActive = async (eoc_id) => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/my_eoc/get_activity/${eoc_id}`
            );
            const data = await response.json();
            return data;
        } catch (error) {
            console.log(error);
        }
    };

    const callSetting = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/config/my_eoc_conf`);
            const data = await response.json();
            // setDataConfig(data);
            dispatch(setEOCConfig(data));
        } catch (error) {
            console.log(error);
        }
    };

    const callSettingActivity = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/config/my_activity_config`
            );
            const data = await response.json();
            dispatch(setActivityConfig(data));
        } catch (error) {
            console.log(error);
        }
    };

    const getMyEOC = async () => {
        let param = "";
        if (profile?.org_level === "02") {
            param = `org_id=${profile?.org_id}`;
        } else {
            param = `area_code=${profile?.area_code}`;
        }
        const response = await fetch(`${process.env.REACT_APP_API_URL}/my_eoc/get_eoc/${profile?.org_level}?${param}`);
        if (response.ok) {
            const data = await response.json();
            if (data.active_eoc.length !== 0) {
                const activityData = await callActivityActive(
                    data.active_eoc[0].eoc_id
                );
                dispatch(setActivityActive(activityData));
                dispatch(setEOCActive(data?.active_eoc[0]));
                dispatch(setTab("1"))
            } else {
                dispatch(setActivityActive(undefined));
                dispatch(setEOCActive(undefined));
            }
            if (data.history_eoc.length !== 0) {
                data.history_eoc.reverse();
                const history_eoc = data.history_eoc.map((item, ind) => ({ id: ind, ...item }))
                dispatch(setEOCHistory(history_eoc));
            } else {
                dispatch(setEOCHistory(undefined));
            }
            setLoading(false);
        } else {
            console.error(response);
        }
    };

    const onClickDetail = async (data) => {
        if (data.wo_eoc_id) {
            setDataActivity(data);
            setOpenDetail(true);
        } else {
            const activityData = await callActivityActive(data.eoc_id);
            setDataActivityHistory(activityData);
            setHistorySelected(data);
            setOpenDetailActivity(true);
        }
    };

    useEffect(() => {
        if (profile) {
            getMyEOC();
            callSetting();
            callSettingActivity();
        }
    }, [profile])

    const handleOpenEOC = (type) => {
        setHeaderLabel(`เปิดศูนย์ปฏิบัติการตอบโต้ภาวะฉุกเฉินระดับ${profile?.org_level_name}`);
        setOpenCreate(true);
    };

    return (
        <div className='h-[calc(100vh-60px)] overflow-auto'>
            <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-6 lg:px-8">
                {eocActive === undefined ? (
                    <div className='w-full mt-6'>
                        <div>
                            <Typography variant='h6'>การปฏิบัติการตอบโต้ภาวะฉุกเฉิน (EOC)</Typography>
                            <Typography variant='body1' color='textSecondary'>เลือกวิธีการตอบโต้ภาวะฉุกเฉิน</Typography>
                        </div>
                        <div className='w-full my-5 md:my-10 flex flex-col md:flex-row gap-5 md:gap-10'>
                            <div onClick={() => handleOpenEOC('openEOC')}
                                className={`flex justify-between w-full h-24 px-4 border border-orange-900 bg-orange-900 bg-opacity-10 hover:bg-orange-900 hover:bg-opacity-20 cursor-pointer rounded`}>
                                <Stack direction="row" spacing={2}>
                                    <div className='h-full content-evenly'>
                                        <Typography variant='h6'>เปิด EOC</Typography>
                                        <Typography variant='subtitle2' color='textSecondary'>เปิดศูนย์ปฏิบัติการตอบโต้ภาวะฉุกเฉินระดับ<span className='font-bold'>{profile?.org_level_name}</span></Typography>
                                    </div>
                                </Stack>
                                <div className='h-full content-evenly'>
                                    <NavigateNextIcon color="action" fontSize="small" />
                                </div>
                            </div>
                            <div onClick={() => setNotOpenEOC(true)}
                                className={`flex justify-between w-full h-24 px-4 border border-green-900 bg-green-900 bg-opacity-10 hover:bg-green-900 hover:bg-opacity-20 cursor-pointer rounded`}>
                                <Stack direction="row" spacing={2}>
                                    <div className='h-full content-evenly'>
                                        <Typography variant='h6'>ไม่เปิด EOC</Typography>
                                        <Typography variant='subtitle2' color='textSecondary'>รายงานการดำเนินกิจกรรมตอบโต้ภาวะฉุกเฉิน โดยไม่เปิด EOC</Typography>
                                    </div>
                                </Stack>
                                <div className='h-full content-evenly'>
                                    <NavigateNextIcon color="action" fontSize="small" />
                                </div>
                            </div>
                        </div>
                    </div >
                ) : (
                    <div className='sm:mt-2 md:mt-4 lg:mt-6 xl:mt-8 sm:mb-2 md:mb-4 lg:mb-6 xl:mb-8 mx-auto px-auto w-full'>
                        <CustomOpenEOC handleSuccess={getMyEOC} />
                    </div>
                )
                }
                <div className='mt-10 mb-3'>
                    <Typography variant='body1'>ประวัติการตอบโต้ภาวะฉุกเฉิน</Typography>
                </div>
                {/* <div className='overflow-hidden w-full mb-4 max-h-[calc(100vh-300px)]'> */}
                <div className='overflow-hidden w-full h-[calc(100vh-352px)] pb-2'>
                    {/* <DataGridMyEOC 
                        columns={columns} 
                        rows={eocHistory ? eocHistory : []} 
                    /> */}
                    <DataGridPro
                        loading={loading}
                        columns={columns}
                        rows={eocHistory ? eocHistory : []}
                        slots={{ loadingOverlay: LinearProgress, toolbar: CustomToolbar }}
                        hideFooter
                        disableRowSelectionOnClick
                    />
                </div>
                <CreateEOCDialog open={openCreate} setOpen={setOpenCreate} headerLabel={headerLabel} handleSuccess={getMyEOC} />
                <HistoryDetailDialog
                    open={openDetailActivity}
                    setOpen={setOpenDetailActivity}
                    eocData={historySelected}
                    activityData={dataActivityHistory}
                />
                <AddActivity open={notOpenEOC} setOpen={setNotOpenEOC} notOpenEOC={true} />
                <DetailActivity
                    open={openDetail}
                    setOpen={setOpenDetail}
                    dataActivity={dataActivity}
                />
            </div >
        </div>
    )
}

export default MyEOC